// Badge definitions — purely client-side derived from progress.
// `progress` is the array returned by /api/progress.

const BADGE_DEFS = [
    {
        id: "first_drop",
        name: { en: "First Drop", es: "Primera Gota" },
        desc: {
            en: "Completed Week 1",
            es: "Completó la Semana 1",
        },
        emoji: "💧",
        check: (p) => p.some((x) => x.week_id === "w1"),
    },
    {
        id: "cycle_master",
        name: { en: "Cycle Master", es: "Maestro del Ciclo" },
        desc: {
            en: "Perfect on the Nitrogen Cycle quiz",
            es: "Quiz perfecto del Ciclo del Nitrógeno",
        },
        emoji: "🔁",
        check: (p) =>
            p.some((x) => x.week_id === "w2" && x.best_score === x.total),
    },
    {
        id: "builder",
        name: { en: "The Builder", es: "Constructor" },
        desc: { en: "Completed Week 3", es: "Completó la Semana 3" },
        emoji: "🔧",
        check: (p) => p.some((x) => x.week_id === "w3"),
    },
    {
        id: "fish_whisperer",
        name: { en: "Fish Whisperer", es: "Susurrador de Peces" },
        desc: { en: "Completed Week 4", es: "Completó la Semana 4" },
        emoji: "🐟",
        check: (p) => p.some((x) => x.week_id === "w4"),
    },
    {
        id: "green_thumb",
        name: { en: "Green Thumb", es: "Pulgar Verde" },
        desc: { en: "Completed Week 5", es: "Completó la Semana 5" },
        emoji: "🌱",
        check: (p) => p.some((x) => x.week_id === "w5"),
    },
    {
        id: "block_boss",
        name: { en: "Block Boss", es: "Jefe del Barrio" },
        desc: { en: "Completed Week 6", es: "Completó la Semana 6" },
        emoji: "👑",
        check: (p) => p.some((x) => x.week_id === "w6"),
    },
    {
        id: "perfect_run",
        name: { en: "Perfect Run", es: "Corrida Perfecta" },
        desc: {
            en: "Aced any single quiz",
            es: "Quiz perfecto en cualquier semana",
        },
        emoji: "★",
        check: (p) => p.some((x) => x.best_score === x.total && x.total > 0),
    },
    {
        id: "sweep",
        name: { en: "Clean Sweep", es: "Barrida Limpia" },
        desc: {
            en: "Aced ALL 6 quizzes",
            es: "Quiz perfecto en LAS 6 semanas",
        },
        emoji: "🏆",
        check: (p) => {
            const perfect = new Set(
                p.filter((x) => x.best_score === x.total).map((x) => x.week_id),
            );
            return (
                ["w1", "w2", "w3", "w4", "w5", "w6"].every((w) => perfect.has(w))
            );
        },
    },
    {
        id: "hot_streak",
        name: { en: "Hot Streak", es: "Racha Caliente" },
        desc: {
            en: "Completed 3+ weeks in a row from W1",
            es: "3+ semanas seguidas desde W1",
        },
        emoji: "🔥",
        check: (p) => {
            const done = new Set(p.map((x) => x.week_id));
            let streak = 0;
            for (const wid of ["w1", "w2", "w3", "w4", "w5", "w6"]) {
                if (done.has(wid)) streak++;
                else break;
            }
            return streak >= 3;
        },
    },
];

export function getBadges(progress, lang = "en") {
    return BADGE_DEFS.map((b) => ({
        id: b.id,
        emoji: b.emoji,
        name: b.name[lang] || b.name.en,
        desc: b.desc[lang] || b.desc.en,
        earned: b.check(progress || []),
    }));
}

export const ALL_WEEKS = ["w1", "w2", "w3", "w4", "w5", "w6"];
